import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';

export interface KlarnaPlacementProps {
  price: number;
  typeOfDataKey: string;
}

const KlarnaPlacementComponent = ({ price, typeOfDataKey }: KlarnaPlacementProps) => {
  useEffect(() => {
    (window as any).KlarnaOnsiteService = (window as any).KlarnaOnsiteService || [];
    (window as any).KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
  }, [price]);

  // @ts-ignore
  return <klarna-placement data-key={typeOfDataKey} data-locale="en-US" data-purchase-amount={price * 100} />;
};

export const KlarnaPlacement = dynamic(() => Promise.resolve(KlarnaPlacementComponent), {
  ssr: false,
});
